import React from "react";
import { MoreInfo } from "@/components/MoreInfo";

const STEPS = [
  ["1. Scegli l'offerta", "Nel Listino vedi il netto per ogni offerta; lo stesso importo compare sulle schede offerta."],
  ["2. Contratto attivo", "La provvigione matura solo quando Venergia attiva il contratto."],
  ["3. Accredito", "Dealer e master: netto sul wallet. Agenzia: pre-fattura e caricamento fattura."],
  ["4. Storico", "In Provvigioni maturate trovi ogni accredito; ogni mese ricevi il riepilogo via email."],
];

export function CommissionGuide() {
  return (
    <MoreInfo title="Come funzionano le provvigioni" testid="commission-guide">
      <div className="grid sm:grid-cols-2 gap-2">
        {STEPS.map(([t, d]) => (
          <div key={t} className="rounded-lg border border-border p-2.5">
            <p className="text-sm font-medium">{t}</p>
            <p className="text-xs text-muted-foreground">{d}</p>
          </div>
        ))}
      </div>
    </MoreInfo>
  );
}
